.input {
  background-color: var(--mantine-color-primary-0);
  color: var(--mantine-color-gray-9);
  border-radius: var(--mantine-radius-sm);
  &[data-error] {
    border: 1px solid var(--mantine-color-error);
  }
  &::placeholder {
    color: var(--mantine-color-gray-6);
  }
}

.label {
  font-size: var(--mantine-font-size-xs);
  background-color: transparent;
}
.loader {
  background-color: var(--mantine-color-primary);
}

.placeholder {
  background-color: var(--mantine-color-gray-0);
  color: var(--mantine-color-gray-6);
}

.text {
  font-size: var(--mantine-font-size-xs);
  line-height: var(--mantine-line-height-xs);
  color: var(--mantine-color-gray-7);
}

.pill {
  background: var(--mantine-color-gray-0);
  color: var(--mantine-color-gray-9);
  border-radius: var(--mantine-radius-sm);
  font-size: var(--mantine-font-size-xs);
  height: fit-content;
  padding-block: 0.15rem;
  padding-inline: var(--mantine-spacing-sm);
}

.chip {
  &[data-disabled="true"] {
    background-color: var(--mantine-color-primary-0);
    color: var(--mantine-color-primary-7);
  }
}

.settings {
  border-bottom: 1px solid var(--mantine-color-gray-2);
}

.panel {
  border-radius: var(--mantine-radius-lg);
  border: 1px solid var(--mantine-color-gray-2);
  padding: var(--mantine-spacing-md);
  background-color: white;
}

.multiselect {
  border-radius: var(--mantine-radius-lg);
  background-color: white;
  border: 1px solid var(--mantine-color-gray-2);
}
